import { voteKey } from './lineupFormat';

/**
 * One row per performance. event_lineup returns a b2b ("Chris Lake b2b Disclosure") as one row per artist, sharing a
 * performance_group_id and the billing name - so the Sets page showed the same set twice and let you pick half of it
 * (operator, 2026-09-23). Here the members fold into their first row, which carries `members` (every artist's row).
 * Rows arrive with members adjacent (event_lineup orders them so), and a group is per day.
 */
export function mergePerformances(lineup = []) {
  const out = [];
  const leadByGroup = new Map();
  for (const row of lineup) {
    if (!row.performance_group_id) {
      out.push(row);
      continue;
    }
    const gk = `${row.performance_group_id}|${row.performance_day ?? ''}`;
    const lead = leadByGroup.get(gk);
    if (!lead) {
      const merged = { ...row, members: [row] };
      leadByGroup.set(gk, merged);
      out.push(merged);
    } else {
      lead.members.push(row);
      if (!lead.spotify_image_url && row.spotify_image_url)
        lead.spotify_image_url = row.spotify_image_url;
    }
  }
  for (const lead of leadByGroup.values()) {
    if (lead.members.length === 1) {
      delete lead.members;
      continue;
    }
    lead.artist_name =
      lead.billing_name ||
      lead.members.map((m) => m.canonical_artist_name || m.artist_name).join(' b2b ');
  }
  return out;
}

/** The vote keys a row stands for: every member of a b2b, or just itself. */
export function rowVoteKeys(row) {
  return (row.members ?? [row]).map((m) => voteKey(m.artist_id, m.performance_day));
}

/**
 * Voters per row: a b2b's row lists everyone who picked any of its artists, once each. Keyed by the lead's
 * artist_id, like every other row, so the lists and grid read it unchanged.
 */
export function mergeVotersByPerformance(votersByArtist, rows) {
  if (!votersByArtist) return votersByArtist;
  const out = { ...votersByArtist };
  for (const row of rows) {
    if (!row.members) continue;
    const seen = new Map();
    for (const m of row.members) {
      for (const v of votersByArtist[m.artist_id] || []) if (!seen.has(v.id)) seen.set(v.id, v);
    }
    out[row.artist_id] = [...seen.values()];
  }
  return out;
}
